import { useEffect, useState } from 'react'

function hasMatchMedia(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
}

// Suit une media query CSS ; false si matchMedia est indisponible (SSR / jsdom).
export function useMediaQuery(query: string): boolean {
  const [value, setValue] = useState(() => (hasMatchMedia() ? window.matchMedia(query).matches : false))

  useEffect(() => {
    if (!hasMatchMedia()) return
    const mql = window.matchMedia(query)
    const onChange = () => setValue(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return value
}
